import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventAttachmentUploadError } from 'entities/Attachment/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseEventAttachmentUploadError) => void

export const useEventAttachmentUploadError = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.AttachmentUploadError, handler), [])
}
